/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import * as React from 'react';
import {PureComponent} from "react";
import {
  IGatewayRegistrationSummaryProps,
  ISiteDetails
} from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import './Summary.scss';
import DIYAppConstants from "../../../utils/DIYAppConstants";
import {Input} from "@scuf/common";

/**
 * This view displays the summary of the gateway registration
 * It displays the following details
 * #The serial number of the gateway
 * #The status of the mapped gateway
 * #The details of the site to which the gateway is mapped
 */
export default class Summary extends PureComponent<IGatewayRegistrationSummaryProps> {
  /**
   * Render the registration summary
   */
  render() {
    let site = this.props.registeredSite;
    return (
      <React.Fragment>
        <div className='ui-reg-summary-container'>
          {this.getRegistrationSummary(site)}
          {this.getFooterBlock()}
        </div>
      </React.Fragment>
    );
  }

  /**
   * Get the complete registration summary
   * @param {ISiteDetails} site
   * @returns {JSX.Element}
   */
  private getRegistrationSummary(site: ISiteDetails): JSX.Element {
    return (
      <div className='ui-reg-summary-block'>
        {this.getSerialNumberElement()}
        {this.getGatewayNameElement(site)}
        {this.getSiteAddressElement(site)}
      </div>);
  }

  /**
   * Get the React element for the serial number
   */
  private getSerialNumberElement() {
    return [
      this.getSummaryTitle(),
      this.getSerialNumberTitle(),
      this.getSerialNumberValue()
    ];
  }

  /**
   * Get the React element for gateway name
   */
   private getGatewayNameElement(site: ISiteDetails) {
    return [
      this.getGatewayNameTitle(),
      this.getGatewayNameValue(site)
    ];
  }

  /**
   * Returns
   * @returns {any}
   */
  private getSerialNumberValue() {
    return <div key='sn-1' className='ui-reg-summary-sn-val'>
      {this.props.serialNumber}
    </div>;
  }

  private getSerialNumberTitle() {
    return <div key='sn-2' className='ui-reg-summary-sub-title'>
      {Summary.SUMMARY_SUB_TITLE_SN}
    </div>;
  }

  private getSummaryTitle() {
    return <div key='sn-3' className='ui-reg-summary-title'>
      {Summary.SUMMARY_TITLE}
    </div>  
  }

  private getGatewayNameTitle() {
    return <div className='ui-gateway-name-title'>
      {Summary.GATEWAY_NAME_TITLE}
    </div>;
  }

  private getGatewayNameValue(site: ISiteDetails) {
    return <div className='ui-gateway-name-value'>
     {site.gatewayName}
    </div>;
  }

  /**
   * Get the Site address element card
   * @param {ISiteDetails} site
   * @returns {(JSX.Element)[]}
   */
  private getSiteAddressElement(site: ISiteDetails): JSX.Element[] {
    return [
      <div key={0} className='ui-reg-summary-sub-title'>
        Site address
      </div>,
      DIYAppConstants.SITE_DETAILS_BLOCK(site)
    ];
  }

  /**
   * Get the footer block in the summary page.
   * It returns a button link to support information.
   * @returns {(JSX.Element)[]}
   */
  // @Todo: Introduce a router
  private getFooterBlock() {
    return [
      <div className='ui-reg-contact-blk' key={3}>
        {Summary.FOOTER_MESSAGE}
      </div>
    ];
  }

  public static readonly FOOTER_MESSAGE = 'For further queries contact support';
  public static readonly SUMMARY_TITLE = 'Summary';
  public static readonly SUMMARY_SUB_TITLE_SN = 'Serial number';
  public static readonly GATEWAY_NAME_TITLE = 'Gateway name';
}
